import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const customerDeliveryDownloadFileDetailService = (histSeq) => {
  return axiosInstance
    .get(
      `${ENDPOINTS.ADMIN.OPERATION_HISTORY.CUSTOMER_DELIVERY.DETAIL}/${histSeq}`,
    )
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
